import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[70vh] text-center px-4 bg-background-50">
      <span className="w-20 h-20 rounded-full bg-background-100 flex items-center justify-center text-primary-500">
        <i className="ri-film-line text-4xl" />
      </span>
      <h1 className="mt-6 font-heading text-5xl md:text-7xl text-foreground-950 tracking-wide">
        404
      </h1>
      <p className="mt-4 text-lg text-foreground-800">页面不存在或已被移除</p>
      <p className="mt-2 text-sm text-foreground-500 font-mono break-all">{location.pathname}</p>
      <div className="mt-8 flex items-center gap-3 flex-wrap justify-center">
        <Link
          to="/"
          className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          返回首页
        </Link>
        <Link
          to="/movie"
          className="px-6 py-3 rounded-md border border-background-300 text-foreground-700 text-sm hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          浏览影视库
        </Link>
      </div>
    </div>
  );
}